import { render } from "./UserView.vue?vue&type=template&id=60f87b3f&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=60f87b3f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f87b3f"]])

export default __exports__